<template>
  <Container type="card-full">
    <div class="main">
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{ project.projectcode }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">平台编号</div>
              <div class="view-value">{{ project.projectno }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content">{{ project.projectname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">预计开始时间</div>
              <div class="view-value">{{ project.prsbjbegtime | longDate }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">预计截止时间</div>
              <div class="view-value">{{ project.prsbjendtime | longDate }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">实际开始时间</div>
              <div class="view-value">{{ project.projectjkactualbegtime | longDate }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">实际结束时间</div>
              <div class="view-value">{{ project.projectjkactualendtime | longDate }}</div>
            </div>
          </div>
          <el-button type="primary" class="button-i" style="margin-right: 8px;" @click.stop="lodopPrint"
            v-if="+this.$store.getters.loginUser.comtype !== 3">打印</el-button>
          <!-- <el-button type="primary" class="button-i" @click.stop="lodopPrint"
            v-if="+this.$store.getters.loginUser.comtype !== 3" @click="exportExcel" :loading="downloadLoading">导出Excel</el-button>   -->
          <!-- 项目详情 -->
          <!-- <div class="split-line"></div>
            <div class="projectAppend">
                <div class="p-append">
                    <div class="p-append-h">
                        <div class="p-append-h-item">
                            供应商名称
                        </div>
                        <div class="p-append-h-item">
                            竞价附件
                        </div>
                    </div>
                    <div class="p-append-b">
                        <div class="p-append-b-item" v-for="item in appendList" :key="item.psuid">
                            <div class="item name">
                                {{item.comfullname}}
                            </div>
                            <div class="item-appendinfo el-n">
                              <div class="view-field">
                                    <div v-if="item.appendurl" class="view-filelist">
                                        <div class="view-fileitem">
                                            <div class="view-filename" @click="downFile(item.appendurl)">
                                                <a :src="uploadAddr + item.appendurl">{{item.appendfilename | toolongOmitted}}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="view-value">无</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
          <!-- 竞价附件——供应商只能看自己的 -->
          <div class="split-line"></div>
          <!-- 报价一览表 -->
           <!-- v-if="+project.projectauserid === +loginUser.userid" -->
          <div style="display: flex;justify-content: flex-end; padding: 2px;" >
            <el-button v-show="+project.prsflg === 6 && +project.projectauserid === +loginUser.userid" type="primary" size="small"
              @click="exportToExcel" icon="el-icon-download">导出EXCEL</el-button>
          </div>
          <div id="bjview-box" style="width:100%;">

            <div class="bjview-box" style="margin:0 auto;">
              <div class="bjview-header">
                <div class="bjview-index">
                  序号
                </div>
                <div class="bjview-name" style="width:400px;">
                  {{ prsName.gys }}
                </div>
                <div class="bjview-name-t">
                  {{ prsName.filename }}
                </div>
                <div class="bjview-list header-jl" style="display: flex;">
                  <span style="flex:12">报价({{ projectQuotationmodeflg.three }})</span>
                  <span v-if="+project.prsbjtimes > 1" style="flex:5;;text-align: center;">
                    报价文件
                  </span>
                  <span v-if="+project.prsbjtimes > 1" style="flex:7;;text-align: center;">
                    报价时间
                  </span>
                </div>
                <!-- <div class="bjview-name-t" v-if="+project.prsbjtimes > 1">
                  报价文件
                </div> -->
                <div class="bjview-name-t" style="width:200px;" v-if="+project.prsbjtimes === 1">
                  报价时间
                </div>
                <div class="bjview-name-t" style="width:100px;">
                  报价人
                </div>
              </div>
              <div v-for="(i, index) in dialogList" :key="i.pbrcomid" class="bjview-item">
                <div class="bjview-index">
                  <div>
                    {{ index + 1 }}
                  </div>
                </div>
                <div class="bjview-name" style="width:400px;">
                  <div>
                    {{ i.origin[0].pbrcomname }}
                  </div>
                </div>
                <div class="bjview-name-t">
                  <div>
                    <div
                      v-if="i.origin[0].appendurl && (+$store.getters.loginUser.comtype != 3 || (+i.pbrcomid === +$store.getters.loginUser.comid && +$store.getters.loginUser.comtype == 3))"
                      class="view-filelist">
                      <div class="view-fileitem">
                        <div class="view-filename" @click="downFile(i.origin[0].appendurl, i.origin[0].appendid)">
                          <a :src="uploadAddr + i.origin[0].appendurl">{{ i.origin[0].appendfilename |
                            toolongOmitted
                            }}</a>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="i.origin[0].appendurl && +$store.getters.loginUser.comtype === 3 && +i.pbrcomid !== +$store.getters.loginUser.comid"
                      class="view-value">不可查看</div>
                    <div v-else class="view-value">/</div>

                  </div>
                </div>
                <div class="bjview-list">
                  <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
                    <div class="item-index" v-if="+project.prsbjtimes > 1">第{{ j.pbtseq }}轮</div>
                    <div class="item-price" v-if="+project.projectquotationmode === 1">￥{{ j.pbramt | qfwVal }}元(
                      <amount :money="String(j.pbramt)" v-if="j.pbramt" />)
                    </div>
                    <div class="item-price" v-else>{{ j.pbrpricerate }}%</div>
                    <template v-if="+project.prsbjtimes > 1">
                      <div
                        v-if="j.pbrpricefileurl && (+$store.getters.loginUser.comtype != 3 || (+j.pbrcomid === +$store.getters.loginUser.comid && +$store.getters.loginUser.comtype == 3))"
                        class="view-filelist" style="border-left: 1px solid #e8eaec;flex: 5;text-align: center;">
                        <div class="view-fileitem">
                          <div class="view-filename" @click="downFile(j.pbrpricefileurl)">
                            <a :src="uploadAddr + j.pbrpricefileurl">{{ j.pbrpricefilename |
                              toolongOmitted
                            }}</a>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="j.pbrpricefileurl && +$store.getters.loginUser.comtype === 3 && +j.pbrcomid !== +$store.getters.loginUser.comid"
                        class="view-value" style="border-left: 1px solid #e8eaec; flex: 5;text-align: center;">不可查看
                      </div>
                      <div v-else class="view-value"
                        style="border-left: 1px solid #e8eaec; flex: 5;text-align: center;">/</div>
                      <div class="item-index" style="border-left: 1px solid #e8eaec;flex:7;text-align: center;">{{
                        j.pbrtime | newDate }}</div>
                    </template>
                  </div>

                </div>
                <!-- <div class="bjview-list" v-if="+project.prsbjtimes > 1">
                  <div v-for="i in i.origin" :key="i.pbrid" class="bjview-list-item">
                    <div>
                    <div
                      v-if="i.pbrpricefileurl && (+$store.getters.loginUser.comtype != 3 || (+i.pbrcomid === +$store.getters.loginUser.comid && +$store.getters.loginUser.comtype == 3))"
                      class="view-filelist">
                      <div class="view-fileitem">
                        <div class="view-filename" @click="downFile(i.appendurl)">
                          <a :src="uploadAddr + i.pbrpricefileurl">{{ i.pbrpricefilename |
                          toolongOmitted
                          }}</a>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="i.pbrpricefileurl && +$store.getters.loginUser.comtype === 3 && +i.pbrcomid !== +$store.getters.loginUser.comid"
                      class="view-value">不可查看</div>
                    <div v-else class="view-value">无</div>
                  </div>
                  </div>
                </div> -->
                <div class="bjview-list-r" v-if="+project.prsbjtimes === 1">
                  <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
                    <div class="item-index">{{ j.pbrtime | newDate }}</div>
                  </div>
                </div>
                <!-- <div class="bjview-name-t">
                  {{i.origin[0].psuoffertime}}
                </div> -->
                <div class="bjview-name-t bjview-red" style="width:100px;">
                  <!-- <div
                    v-if="+i.origin[0].psuamtcommituserid && +i.origin[0].psuamtcommituserid !== +i.origin[0].psuuserid">
                    系统自动确认</div>
                  <div v-else> -->
                  <div style="text-align:center;">{{ i.origin[0].psuname }}</div>
                  <!-- <div>{{i.origin[0].psuamtcommittime | longDate}}</div> -->
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import common from '@/mixin/common'
import dayjs from 'dayjs'
import amount from '../common/amount'
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
export default {
  name: "biddingView",
  mixins: [common],
  data() {
    return {
      project: this.$route.params.project,
      appendList: [],
      BJList: [],
      dialogList: [],
      loginUser: this.$store.getters.loginUser
    }
  },
  created() {
  },
  mounted() {
  },
  async activated() {
    await this.init()
    this.getModel()
    this.getAppend()
    this.getBJList()
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    },
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return {
          one: '报价',
          two: '金额报价',
          three: '金额'
        }
      }
      if (+this.project.projectquotationmode === 2) {
        return {
          one: '上浮率报价',
          two: '最高上浮率报价',
          three: '上浮率'
        }
      }
      if (+this.project.projectquotationmode === 3) {
        return {
          one: '下浮率报价',
          two: '最高下浮率报价',
          three: '下浮率'
        }
      }
      if (+this.project.projectquotationmode === 4) {
        return {
          one: '折扣率报价',
          two: '最低折扣率报价',
          three: '折扣率'
        }
      }
      return {
        one: '报价',
        two: '金额报价',
        three: '金额'
      }
    },
    prsName() {
      // 竞拍方案，比选文件
      if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
        return {
          gys: '竞价单位',
          filename: '竞价方案'
        }
      }
      else if (+this.project.prsflg === 4 || +this.project.prsflg === 5) {
        return {
          gys: '竞拍单位',
          filename: '竞拍方案'
        }
      }
      else if (+this.project.prsflg === 6) {
        return {
          gys: '比选单位',
          filename: '评审文件'
        }
      } else {
        return {
          gys: '竞价单位',
          filename: '竞价方案'
        }
      }
    }
  },
  filters: {
    longDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4)
        }
        else {
          return val
        }
      }
    }
  },
  components: { amount },
  methods: {
    exportToExcel() {
      const projectquotationmodeDesc = ['', '报价（金额）', '上浮率%', '下浮率%', '折扣率%']
      let data = this.dialogList.map((i, index) => {
        let obj = {}
        obj['序号'] = index + 1
        obj['比选单位'] = i.origin[0].pbrcomname
        let str = []
        let timeStr = []
        let name = ''
        for (let j = 0; j < i.origin.length; j++) {
          const item = i.origin[j]
          if (name == '') name = item.psuname
          if (+this.project.prsbjtimes > 1) {
            str.push(`第${i.origin[j].pbtseq}轮 ${this.project.projectquotationmode === 1 ? item.pbramt + '元' : item.pbrpricerate + '%'}`)
            timeStr.push(`第${i.origin[j].pbtseq}轮 ${dayjs(item.pbrtime).format('YYYY-MM-DD HH:mm:ss')}`)
          } else {
            str.push(`${this.project.projectquotationmode === 1 ? item.pbramt + '元' : item.pbrpricerate + '%'}`)
            timeStr.push(`${dayjs(item.pbrtime).format('YYYY-MM-DD HH:mm:ss')}`)
          }
        }
        obj[projectquotationmodeDesc[+this.project.projectquotationmode]] = str.join('\n')
        obj['报价时间'] = timeStr.join('\n')
        obj['报价人'] = name
        return obj
        
      })
      const cols = ['序号', '比选单位', projectquotationmodeDesc[+this.project.projectquotationmode], '报价时间', '报价人']
      // if (this.project.projectdoneflg === 6) {
      const worksheet = XLSX.utils.json_to_sheet(
        data,
        {
          header: cols
        }
      );
      // }
      // 设置列宽
      const sheet = XLSX.utils.aoa_to_sheet

      const max_width = data.reduce((w, r) => Math.max(w, r['比选单位'].length), 10);
      worksheet["!cols"] = [{ wch: 10 }, { wch: max_width * 2.2 }, { wch: max_width * 2.2 }, { wch: max_width * 2.2 }];

      // 生成blob对象
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // 生成blob对象
      const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })], { type: 'application/octet-stream' });
      var wbout = XLSX.write(workbook, { bookType: "xlsx", bookSST: true, type: "array" });
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        this.project.projectname + "报价记录.xlsx"
      )
    },
    init() {
      this.project = this.$route.params.project
      this.appendList = []
      this.BJList = []
    },
    async getModel() {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: { projectid: this.project.projectid }
      })
      this.project = res
    },
    async getAppend() {
      let res = await request({
        url: '/xmgl/pbr/checkJjPlan',
        method: "get",
        params: { projectid: this.project.projectid }
      })
      if (+this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.comid === +this.$store.getters.loginUser.comid
        })
      }
      this.appendList = res
    },
    async getBJList() {
      let model = {}
      model.pbrprojectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getbjList',
        method: "get",
        params: model
      })
      if (+this.project.projectpricelistflag === 0 && +this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.pbrcomid === +this.$store.getters.loginUser.comid
        })
      }
      res.map(e => {
        e.psuoffertime = dayjs(e.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
      })
      this.dialogList = this.Sortbycomid(res)
    },
    Sortbycomid(beforeData) {
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrcomid) === -1) {
          afterData.push({
            pbrcomid: beforeData[i].pbrcomid,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrcomid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrcomid == beforeData[i].pbrcomid) {
              afterData[j].origin.push(beforeData[i]);
              // afterData[j].origin.sort((a,b) => {
              //   return Number(a.pbramt) - Number(b.pbramt)
              // })
              break;
            }
          }
        }
      }
      return afterData
    },
    async lodopPrint() {  //打印
      let { href } = this.$router.resolve({ name: 'pbrCenterDY', query: { projectid: this.project.projectid } })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  font-size: 14px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.view-filename {
  color: #409EFF;
  cursor: pointer;
  flex: 1;
}

.p-append-h {
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
  display: flex;
  justify-content: space-around;
  text-align: center;
  border: 1px solid #e8eaec;
}

.p-append-h-item {
  flex: 1;
}

.p-append-h-item:first-child {
  border-right: 1px solid #e8eaec;
}

.p-append-b {
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.p-append-b-item {
  display: flex;
  text-align: center;
  border-bottom: 1px solid #e8eaec;
  height: 31px;
  line-height: 31px;
}

.p-append-b-item div:first-child {
  border-right: 1px solid #e8eaec;
}

.p-append-b-item div {
  flex: 1;
}

.el-n {
  white-space: nowrap;
  /*设置不换行*/
  overflow: hidden;
  /*设置隐藏*/
  text-overflow: ellipsis;
}

.name {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-box {
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.bjview-header {
  display: flex;
  // justify-content: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
}

.bjview-index {
  text-align: center;
  width: 50px;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-item {
  display: flex;
  line-height: 35px;
}

.bjview-name {
  overflow: hidden;
  width: 210px;
  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-list-r {
  width: 200px;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  // border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-name-t {
  overflow: hidden;
  width: 180px;
  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name:last-child {
  border-right: none;
}

.header-jl {
  border-bottom: 1px solid #e8eaec;
}

.bjview-list {
  flex: 4;
  -webkit-box-flex: 4;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-list-item {
  display: flex;
  padding-left: 10px;
  border-bottom: 1px solid #e8eaec;
  // height:100%;
}

.bjview-list-item:last-child {

  height: 100%;
}

.item-index {
  // width: 150px;
  flex: 2;
  -webkit-box-flex: 1;
  border-right: 1px solid #e8eaec;
  text-align: center;
}

.item-price {
  padding-left: 10px;
  // width: 350px;
  flex: 8;
  -webkit-box-flex: 8;
}

.bjview-button {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-i {
  margin: 30px 0 auto;
  width: 200px;
}

.bjview-red {
  color: red;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform:translate(-50%,-50%);
}
</style>
